import cx from "classnames";
import { Card } from "common/styleguide/Card";
import { queryStringSet } from "lib/utils";
import queryString from "query-string";
import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import styles from "./TabCard.scss";

// "smart" accordion that handles its own internal state.
// Note that if you use this, you CANNOT control the state
// of the accordion from the outside. If you need to
// control the state of the accordion from outside,
// use an <TabCardWrapper> and manage the `expanded`
// and onToggle prop of each <TabCardItem> yourself.
//
// Important caveats:
// - TabCard items must have a title
// - TabCard item titles must be unique
// - TabCard item titles must not change
export class TabCard extends React.PureComponent {
  constructor(props) {
    super(props);
    if (!props.children) {
      throw Error("TabCard must be initialized with at least one tab");
    }
    if (!this.props.selectedTab !== !this.props.onChange) {
      throw Error("TabCard must be rendered with both onChange and selectedTab, or neither");
    }
    const firstChild = React.Children.toArray(props.children)[0];

    this.state = {
      selectedTab: props.selectedTab ? null : firstChild.props.id,
    };
  }

  componentDidMount() {
    const { ALLOW_UNSAFE_TAB_WIDTH } = this.props;
    // this is implemented as an inline'd IF
    // so that it can be minified away in prod
    if (process.env.NODE_ENV !== "production" && !ALLOW_UNSAFE_TAB_WIDTH) {
      const tabs = Array.from(this._tabs.children);
      // minus 14px for each tab because we shave the padding by 7px on mobile
      const tabWidth = tabs.reduce((width, tab) => width + tab.getBoundingClientRect().width - 14, 0);
      if (tabWidth > 355) {
        throw Error(
          `TabCard width exceeds 355px on this page (currently ${tabWidth}px). See https://github.com/ridewithgps/ridewithgps/issues/6978 for details on why this is important.`
        );
      }
    }
  }

  selectItem = (id) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(id);
    } else {
      this.setState({ selectedTab: id });
    }
  };

  render() {
    const { children } = this.props;
    const selectedTab = this.props.selectedTab || this.state.selectedTab;
    const childrenArr = React.Children.toArray(children);
    return (
      <div className={styles.TabCard}>
        <div
          className={styles.tabs}
          ref={(r) => {
            this._tabs = r;
          }}
        >
          {childrenArr.map((c) => (
            <h2
              data-heading-alt
              key={c.props.id}
              className={cx(styles.tabHeading, selectedTab === c.props.id && styles.activeTab)}
              onClick={() => this.selectItem(c.props.id)}
            >
              {c.props.title}
            </h2>
          ))}
        </div>
        <Card noPadding>{childrenArr.find((c) => c.props.id === selectedTab)}</Card>
      </div>
    );
  }
}

const _URLTabCard = ({ children, name, location, history }) => {
  const firstChild = React.Children.toArray(children)[0];
  const [selectedTab, setSelectedTab] = useState(queryString.parse(location.search)[name] || firstChild.props.id);
  const onSelectedTabChange = (id) => {
    setSelectedTab(id);
    queryStringSet(location, name, id, history);
  };

  return (
    <TabCard selectedTab={selectedTab} onChange={onSelectedTabChange}>
      {children}
    </TabCard>
  );
};

export const URLTabCard = withRouter(_URLTabCard);

export class TabCardItem extends React.PureComponent {
  render() {
    const { children } = this.props;
    return children;
  }
}
